import { addMilliseconds } from 'date-fns';
import { Middleware } from 'redux';

import { getDataFromStorage, setDataToStorage } from 'hooks/useRefreshTimer';
import { authSuccess } from 'store/auth/authSlice';
import { getUser } from 'store/auth/selectors';

import {
  TIMEOUT_DURATION,
  TIMER_NAME,
} from 'components/shared/Popups/LimitTimeOfferPopup';

export const refreshLimitOfferPopupMiddleware: Middleware =
  (store) => (next) => (action) => {
    if (action.type === authSuccess.type) {
      const user = getUser(store.getState());
      const storageData = getDataFromStorage(TIMER_NAME);

      if (storageData && !user?.is_premium) {
        setDataToStorage(TIMER_NAME, {
          ts: addMilliseconds(new Date(), TIMEOUT_DURATION),
          isExecuted: false,
        });
      }
    }

    return next(action);
  };
